import { api, FilterOptionsResponse } from "../index";

import { Transaction } from "./dto/transactions.dto";

const TRANSACTION_ENDPOINT = "/transaction";
const ADMIN_ENDPOINT = "/admin";

export const TransactionsAPI = api.injectEndpoints({
	endpoints: build => ({
		getTransactions: build.query<FilterOptionsResponse<Transaction[]>, { page: number; perPage: number }>({
			query: ({ page, perPage }) => ({
				url: `${TRANSACTION_ENDPOINT}/list`,
				params: { page, perPage },
				method: "GET"
			}),
			providesTags: []
		}),
		getAdminTransactions: build.query<FilterOptionsResponse<Transaction[]>, { page: number; perPage: number }>({
			query: ({ page, perPage }) => ({
				url: `${ADMIN_ENDPOINT}/transactions`,
				params: { page, perPage },
				method: "GET"
			}),
			providesTags: []
		})
	})
});

export const { useLazyGetTransactionsQuery, useLazyGetAdminTransactionsQuery } = TransactionsAPI;
